import React, {useEffect} from 'react';
import {RecoilRoot} from 'recoil';

// import './assets/base.scss'
import './App.scss';
import DebugRecoilWrapper from './Util/DebugRecoilWrapper';
// import './common/form.scss';
import SuspenseComponent from './common/SuspenseComponent';

const Id4ThemeProvider = React.lazy(() => import('./Id4ThemeProvider'));
const AppRouter = React.lazy(() => import('./common/AppRouter'));

function App() {
    useEffect(() => {
        document.title = `CLM4Bank - ${process.env['REACT_APP_ENV_NAME'] || 'Local'}`;
    }, []);

    return (
        <div className="App bg-body">
            <RecoilRoot>
                <DebugRecoilWrapper />
                <React.Suspense fallback={<SuspenseComponent />}>
                    <Id4ThemeProvider>
                        <AppRouter />
                    </Id4ThemeProvider>
                </React.Suspense>
            </RecoilRoot>
        </div>
    );
}

export default App;
